export default "__VITE_ASSET__DWuthiyg__"